import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson2DefaultStartCode = `%lang starknet
// Functions can take arguments and return results
${doNotModifyCodeAbove}`;

export const lesson2DefaultMiddleCode = `// TODO: fix the method signature to make the tests pass
func takes_two_arguments_and_returns_one() -> () {`;

export const lesson2DefaultEndCode = `    ${doNotModifyCodeBelow}
    return (res=a+b);
}

@external
func test_sum{syscall_ptr : felt*}() {
    let (sum) = takes_two_arguments_and_returns_one(1, 2);
    assert sum = 3;
    return ();
}`;
